<template>
  <modals-request
    id="UserStoreEditTemplateValueModal"
    v-model="payload"
    :request-class="proxyRequest"
    persistent
    @success="success($event)"
  >
    <template #open="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-file-edit-outline</v-icon>
      </v-btn>
    </template>
    <v-row
      class="pb-3"
      justify="start"
    >
      <v-col cols="6">
        <chip
          :payload="storeNameChip"
          :loading="loading"
        />
      </v-col>
    </v-row>
    <product-template-content-values
      :value="payload"
    />
  </modals-request>
</template>

<script>
import ModalsRequest from '@/app/arch/components/modals/ModalsRequest.vue';
import ProductTemplateContentValues from '@/app/modules/contacard/produto/templates/produto/components/ProductTemplateContentValues.vue';
import TemplateProductStoreService from 'App/users/services/TemplateProductStoreService';
import Chip from '@/app/arch/components/global-components/Chip.vue';

export default {
  name: 'UserStoreEditTemplateValueModal',
  components: { ModalsRequest, ProductTemplateContentValues, Chip },
  props: {
    row: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
  data: () => ({
    requestClass: TemplateProductStoreService,
  }),
  computed: {
    proxyRequest() {
      return (payload) => this.requestClass.edit(
        this.value,
        this.preparePayload(payload),
      );
    },
    getId() {
      return this.value;
    },
    payload() {
      return this.row;
    },
    preparePayload() {
      return (payload = {}) => ({
        idTemplate: payload.idTemplate,
        idProdutoServicoIntegrador: this.getFaultProdutoIntegradorId(payload),
        idProdutoServico: payload.produtoServico.id,
        indSomarTaxasBonus: payload.indSomarTaxasBonus,
        ...this.formatValues(payload.valores),
      });
    },
    storeNameChip() {
      return {
        color: '#F9FAFB',
        textColor: '#69737D',
        label: this.userStoreForm.payload.nomLoja,
      };
    },
    loading() {
      return this.userStoreForm.loading;
    },
  },
  methods: {
    success() {
      this.refreshCrudList();
    },
    formatValues(valores = {}) {
      return {
        valores: Object.keys(valores)
          .map(
            this.formatItemValue(valores),
          ).reduce(
            this.makeToObj,
            {},
          ),
      };
    },
    formatItemValue(valores) {
      return (key) => ({
        key,
        values: valores[key].map(
          (item) => ({
            ...item,
            valor: Number(
              String(item.valor).replace(',', '.'),
            ),
          }),
        ).filter(
          this.removeEmptyItems,
        ),
      });
    },
    removeEmptyItems(item) {
      return item.tipoValorTemplate !== '' && item.tipoComissaoTemplate !== '';
    },
    makeToObj(obj, item) {
      return {
        ...obj,
        [item.key]: item.values,
      };
    },
    getFaultProdutoIntegradorId(payload = {}) {
      if (payload && payload.produtoServicoIntegrador && payload.produtoServicoIntegrador.id) {
        return payload.produtoServicoIntegrador.id;
      }
      return '';
    },
  },
  inject: {
    userStoreForm: {
      default() {
        return {
          payload: {
            nomLoja: '',
          },
          loading: '',
        };
      },
    },
    refreshCrudList: {
      default() {
        return () => {};
      },
    },
  },
};
</script>

<style scoped>
#UserStoreEditTemplateValueModal {
  width: max-content;
}
</style>
